export const observationCodes = {
  externalProvider: 'existing-pcp-details',
  pharmacy: 'pharmacy',
  height: 'height',
  weight: 'weight',
  menopauseRatingScale: 'menopause-rating-scale',
  menopauseStage: 'menopause-stage',
  providerNote: 'provider-note',
} as const;
